import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { AppSettingEntity } from '../post/app-settings.entity';
import { WhatsappGroupsEntity } from './whatsappgrp.entity';
import { WhatsappController } from './whatsapp.controller';
import { WhatsappService } from './whatsapp.service';
import { OtherMsgEntity } from './msgcnt.entity';
@Module({
    imports: [
      TypeOrmModule.forFeature([AppSettingEntity,WhatsappGroupsEntity,OtherMsgEntity]),
    ],
    controllers: [WhatsappController],
    providers: [WhatsappService],
    exports:[WhatsappService],
})
export class WhatsappModule {}